<template>
  <div class="dicom-view-main-container">
    <div class="section-holder">
      <div class="title-text">请复制以下链接，用浏览器打开查看</div>
      <div class="sub-intro">
        建议在WIFI环境下查看
      </div>
      <div class="report-holder">
        <div class="report-input-area">
          <textarea
            v-model="urlData.fileUrl"
            class="link-input"
            style="width: 100%; height: 100%"
            placeholder="粘贴报告链接"
          />
        </div>
      </div>
      <div class="bottom-button" @click="copyToClipBoard(urlData.fileUrl)">
        复制链接
      </div>
    </div>

    <div class="section-holder">
      <div class="title-text">验证信息</div>
      <div class="sub-intro">
        打开链接后，输入验证信息
      </div>
      <div class="report-holder">
        <div class="report-input-area">
          <textarea
            v-model="urlData.verifyCode"
            class="link-input"
            style="width: 100%; height: 100%"
            placeholder="粘贴报告链接"
          />
        </div>
      </div>
      <div class="bottom-button" @click="copyToClipBoard(urlData.verifyCode)">
        复制验证信息
      </div>
    </div>
  </div>
</template>
<script>
import * as copy from 'copy-to-clipboard';

export default {
  name: 'DicomView',
  data() {
    return {
      urlData: {
        fileUrl: '',
        verifyCode: '',
      },
      url: '',
      toastObj: {},
    };
  },
  created() {
    this.urlData.fileUrl = this.$route.query.file_url;
    this.urlData.verifyCode = this.$route.query.verify_code;
  },
  methods: {
    copyToClipBoard(txt) {
      copy(txt, {
        onCopy: () => {
          this.toastObj = this.$createToast({
            txt: '复制成功',
            mask: false,
            type: 'txt',
            time: 1000,
          });
          this.toastObj.show();
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.dicom-view-main-container {
  min-height: 100vh;
  padding-top: rem(10);
  background-color: rgb(247, 247, 247);
  .section-holder {
    margin-right: rem(10);
    margin-bottom: rem(10);
    margin-left: rem(10);
    padding: rem(15);
    padding-bottom: rem(20);
    background-color: white;
    border-radius: rem(4);
    .title-text {
      margin-bottom: rem(10);
      color: #323232;
      font-size: rem(15);
      line-height: 1;
    }
    .sub-intro {
      margin-bottom: rem(10);
      color: #999;
      font-size: rem(12);
      line-height: 1;
    }
    .report-holder {
      display: flex;
      flex-flow: row nowrap;
      align-items: stretch;
      width: 100%;
      height: rem(62);
      border: 1px solid rgba(226, 226, 226, 1);
      border-radius: 2px;
      .report-input-area {
        flex-grow: 1;
        padding: rem(10);
        .link-input {
          display: block;
          color: #666;
          font-size: rem(13);
          border: none;
          resize: none;
          &::placeholder {
            color: #c2c2c2;
            font-size: rem(13);
          }
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .bottom-button {
    height: rem(44);
    margin-top: rem(15);
    color: #fff;
    font-size: rem(16);
    line-height: rem(44);
    text-align: center;
    background: #39d167;
    border-radius: rem(2);
  }
}
</style>
